import { render, staticRenderFns } from "./LanguagesAccount.html?vue&type=template&id=1946cee2&scoped=true&"
import script from "./LanguagesAccount.ts?vue&type=script&lang=ts&"
export * from "./LanguagesAccount.ts?vue&type=script&lang=ts&"
import style0 from "@/scss/components/navbar/_languages.scss?vue&type=style&index=0&id=1946cee2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1946cee2",
  null
  
)

export default component.exports